


import React from 'react';


export default function AboutUs() {
  return (
      <section>
          <div className='refer'>
              <h2>Now Refer & Eran ₹ 500 for every referral*</h2>
              <p>*Term and conditions will be applied </p>
          </div>
  
  <div className='about-section'>
      <div className='about'>
          <div className='about-left'>
              <h3>ABOUT US </h3>
              <p className=''>Doorstep Wash & Dryclean service</p>
          </div>
          <div className='about-middle'>
              <div>
              <h4>Home</h4>
              <p>Sign In</p>
              <p>Register</p>
              </div>
                
            <h4>Pricing</h4>
              <div>
              <h4>Career</h4>
              <p>Blogs</p>
              <p>Create</p>
              </div>

            <h4>Contact</h4>
          </div>
          <div>
              <h4>SOCIAL MEDIA</h4>
              <div className='social'>
    <i className="fa fa-facebook"></i>
    <i className="fa fa-instagram"></i>
    <i className="fa fa-twitter"></i>

</div>
          </div>


      </div>

  </div>
  </section>)
}
